<script>
import { zendeskActions, zendeskValidateActions } from '@state/helpers'
import zendesk from '@mixins/zendesk-utils.js'
import OrderProduct from '@components/order-product.vue'
import SubHeader from '@components/sub-header'

const PRODUCT_TYPE = {
  REMOVAL: 'removal',
  NORMAL: 'normal'
};

export default {
  name: 'ProductsList',
  components: {
    SubHeader,
    OrderProduct
  },
  mixins: [zendesk()],
  props: {
    componentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: this.componentData.type === 'freshness_guarantee' ?
        this.componentData.title : this.$t('WIDGETS.PRODUCTS_LIST.TITLE'),
      deletedTitle: this.$t('WIDGETS.PRODUCTS_LIST.DELETED_TITLE'),
      selectedProducts: [],
    }
  },
  computed: {
    availableProducts() {
      return this.componentData.items.filter(prod => prod.product_type !== PRODUCT_TYPE.REMOVAL);
    },
    removedProducts() {
      return this.componentData.items.filter(prod => prod.product_type === PRODUCT_TYPE.REMOVAL);
    },
    isFreshness() {
      return this.componentData.type === 'freshness_guarantee';
    },
    hasItems() {
      return this.componentData.items.length
    }
  },
  watch: {
    selectedProducts () {
      const { name } = this.$options

      this.commitCustomField({
        value: JSON.stringify(this.selectedProducts),
        key: 'products',
      })

      if (this.selectedProducts.length > 0) {
        this.commitValidatedField({
          type: 'function',
          key: 'productsValidation',
          name,
          value: this.selectedProducts,
          message: this.$t('COMMON.REQUIRED_PRODUCT.BASE'),
        })
      } else {
        this.removeValidatedField({ key: 'productsValidation' })
      }
    }
  },
  created () {
    if(this.isFreshness && this.hasItems) this.validateRequired()
  },
  methods: {
    ...zendeskActions,
    ...zendeskValidateActions,
    isLastElement(list, current) {
      return current === list.length - 1;
    },
     removeToppings(object){
       object.toppings = [];
       return object
    },
    onProductsUpdate(product) {
      const { product_id: productId } = product.data;

      this.selectedProducts = this.selectedProducts.filter( p => p.product_id !== productId);

      if (product.checked) {
        this.selectedProducts = [...this.selectedProducts, this.removeToppings(product.data)];
      }
    },
    validateRequired() {
      const {name} = this.$options;
      this.commitRequiredFields({
        type: 'function',
        key: 'productsValidation',
        name,
        message: this.$t('COMMON.REQUIRED_PRODUCT.BASE'),
      })
    }
  }
}
</script>

<template>
  <div>
    <div :class="$style.container">
      <SubHeader
        :class="$style.container__header"
        :text="title"
      />
      <OrderProduct
        v-for="(product, i) in availableProducts"
        :key="i"
        :product="product"
        :disabled="false"
        :selectable="true"
        :freshness="isFreshness"
        :last="isLastElement(availableProducts, i)"
        @productChecked="onProductsUpdate"
      />
    </div>
    <div
      v-if="removedProducts.length"
      :class="$style.container">
      <SubHeader
        :class="$style.container__header"
        :text="deletedTitle"
        :length="removedProducts.length"
      />
      <OrderProduct
        v-for="(product, i) in removedProducts"
        :key="i"
        :product="product"
        :disabled="true"
        :selectable="false"
        :last="isLastElement(removedProducts, i)"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
  @import '@design';

  .container {
    padding: 1rem 0 1rem 0;
    margin: $size-spacing-medium 0;
    background-color: $background-container;
  }

</style>
